import {
  dateFormats,
  formattedDateTime,
} from "@/react/helpers/dateTimeHelpers/formattedDateTime";
import { useUsageAndConfigLimits } from "@circle-react/components/LiveStreams/hooks";
import { usePunditUserContext } from "@circle-react/contexts";
import { Attendees } from "./Attendees";
import { StreamHours } from "./StreamHours";

export const Limits = () => {
  const { currentCommunity } = usePunditUserContext();
  const {
    monthlyHourLimit,
    monthlyHourUsage,
    hostLimit,
    participantLimit,
    streamingDurationResetDate,
    isLoading,
    refetchAddons,
  } = useUsageAndConfigLimits();
  const doesCommunitySupportLiveStreams =
    currentCommunity?.supports_live_streams;

  if (!doesCommunitySupportLiveStreams) {
    return null;
  }

  return (
    <div className="mb-4 flex w-full flex-col gap-4 md:flex-row">
      <StreamHours
        isLoading={isLoading}
        limit={monthlyHourLimit}
        usage={monthlyHourUsage}
        resetDate={
          streamingDurationResetDate
            ? formattedDateTime({
                dateTime: streamingDurationResetDate,
                format: dateFormats.long_date_short_time,
              })
            : undefined
        }
        onPurchase={refetchAddons}
      />
      <Attendees
        isLoading={isLoading}
        hosts={hostLimit}
        participants={participantLimit}
        onPurchase={refetchAddons}
      />
    </div>
  );
};
